import React, { Suspense } from "react"
import * as styles from "./Laptop.module.css"
import elementSplitter from "../utils/elementSplitter"
import { StaticImage } from "gatsby-plugin-image"

type LaptopType = {
  children: React.ReactElement
}

const Laptop = ({ children }: LaptopType) => {
  const { images } = elementSplitter(children)

  return (
    <div className={styles.container}>
      <StaticImage
        src="../../../../images/laptop.webp"
        alt="laptop"
        placeholder="dominantColor"
        width={700}
        style={{ margin: 0 }}
      />

      <Suspense fallback={<h3>Loading...</h3>}>
        <div className={styles.screen}>{images?.[0]}</div>
      </Suspense>
    </div>
  )
}

export default Laptop
